import {Module} from "@/modules";
import {Country, Region} from "./entity";
import {EventEmitter} from "@/modules/base/events";
import {GameCreator} from "@/modules/base/services/gameCreator";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";
import WorldFactory from "@/modules/base/services/factories/WorldFactory";
import CountryRandomizer from "@/modules/base/services/CountryRandomizer";
import messages from "./resources/messages";
import {routes} from "./resources/routes";
import {DatabaseEventSubscriber} from "@/modules/base/subscribers/DatabaseEventSubscriber";
import GlobalResolver from "@/modules/base/services/GlobalResolver";
import {WelcomeEventSubscriber} from "@/modules/base/subscribers/WelcomeEventSubscriber";
import {SectionLoader} from "@/modules/base/services/SectionLoader";
import MemoryLogger from "@/modules/base/services/MemoryLogger";

export class BaseModule extends Module {
  messages = messages;
  routes = routes;

  eventSubscribers = [
    DatabaseEventSubscriber,
    WelcomeEventSubscriber,
  ];

  public entities = [
    Country,
    Region,
  ];

  init() {
    super.init();

    this.app.bind<EventEmitter>(EventEmitter).to(EventEmitter);
    this.app.bind<SectionLoader>(SectionLoader).to(SectionLoader).inTransientScope();
    this.app.bind<GameCreator>(GameCreator).to(GameCreator);
    this.app.bind<MemoryLogger>(MemoryLogger).to(MemoryLogger);

    this.app.bind<WorldFactory>(WorldFactory).to(WorldFactory);
    this.app.bind<CountryRandomizer>(CountryRandomizer).to(CountryRandomizer);

    this.app.bind<ConfigRepository>(ConfigRepository).to(ConfigRepository);
    this.app.bind<GlobalResolver>(GlobalResolver).to(GlobalResolver);
  }

  public async boot() {
    super.boot();

    this.app.get(EventEmitter).init();
  }
}